var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"title font-weight-bold text-uppercase"},[_vm._v("\n  "+_vm._s(_vm.title || 'Sem título')+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }